import { render, staticRenderFns } from "./UserStatusComponent.vue?vue&type=template&id=c90553b0&scoped=true"
import script from "./UserStatusComponent.vue?vue&type=script&lang=ts"
export * from "./UserStatusComponent.vue?vue&type=script&lang=ts"
import style0 from "./UserStatusComponent.vue?vue&type=style&index=0&id=c90553b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90553b0",
  null
  
)

export default component.exports